import { z } from 'zod';
import { russianPhoneSchema } from '../const/russianPhoneSchema';

const base = {
    code: z
        .string()
        .trim()
        .regex(/^\d{6}$/, { message: 'Код должен состоять из 6 цифр' }),
};

const phoneVerifySchema = z.object({
    provider: z.literal('phone'),
    phoneNumber: russianPhoneSchema,
    ...base,
});

const emailVerifySchema = z.object({
    provider: z.literal('email'),
    email: z
        .string()
        .trim()
        .toLowerCase()
        .min(1, { message: 'Это поле обязательно для заполнения' })
        .email('Неверный формат почты'),
    ...base,
});

export const verifyOTPSchema = z.discriminatedUnion('provider', [phoneVerifySchema, emailVerifySchema]);

export type VerifyOTPSchema = z.infer<typeof verifyOTPSchema>;
